import { useEffect } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';
import { logout } from 'store/auth/actions';
import './style.scss';

interface LogoutPageProps {
  isFetchingMe: boolean,
  logout: Function,
}

const LogoutPage = ({ isFetchingMe, logout }: LogoutPageProps) => {
  useEffect(() => {
    setTimeout(logout, 200);
  }, [logout]);

  return <div className="page page-logout">
    <h1>{isFetchingMe ? '...' : 'Logging out...'}</h1>
  </div>;
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingMe: store.rootReducer.auth.isFetchingMe,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  logout,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LogoutPage);